import "pluggin_variable_weight/main";
const processInclude = require('base/util');

$(document).ready(() => {
    processInclude(require('./storeLocator/selectStoreModal'));
});
